import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useSeo } from "../lib/useSeo";

const API = process.env.REACT_APP_BACKEND_URL;

export default function PartnersPage() {
  const [partners, setPartners] = useState([]);
  const [loaded, setLoaded] = useState(false);
  useSeo({
    title: "Our Partners & Collaborators",
    description: "Meet the technology companies, AI platforms, educators and business service providers in the AI Prompt Shortcuts Partner Network.",
  });
  useEffect(() => {
    axios.get(`${API}/api/partners`).then((r) => setPartners(r.data)).catch(() => {}).finally(() => setLoaded(true));
  }, []);

  return (
    <div className="bg-[#FAFAF7] min-h-screen py-14 lg:py-20 px-4 sm:px-6 lg:px-8" data-testid="partners-page">
      <div className="max-w-6xl mx-auto">
        <div className="text-center max-w-3xl mx-auto">
          <p className="font-display text-[#B8962E] font-bold text-xs sm:text-sm tracking-[0.16em] uppercase mb-3">Partner Network</p>
          <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight">Our Partners &amp; Collaborators</h1>
          <p className="text-slate-500 mt-4 text-sm sm:text-base">
            Technology companies, AI platforms, educators and business service providers we work with to help more people get real results from AI.
          </p>
        </div>

        {loaded && partners.length === 0 && (
          <p className="text-center text-slate-400 mt-16" data-testid="partners-empty">
            Our first partners are joining soon. Want to be among them?
          </p>
        )}

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5 mt-12" data-testid="partners-grid">
          {partners.map((p, i) => (
            <a key={i} href={p.website_url} target="_blank" rel="noopener noreferrer"
              data-testid={`partner-card-${i}`}
              className="group bg-white border border-slate-200 rounded-2xl p-6 flex flex-col items-center justify-center gap-3 min-h-[150px] hover:border-[#D4AF37]/60 hover:shadow-lg hover:-translate-y-0.5 transition-all">
              <img src={p.logo_url && p.logo_url.startsWith("/") ? `${API}${p.logo_url}` : p.logo_url}
                alt={`${p.company_name} logo`} className="max-h-16 max-w-[80%] object-contain"
                onError={(e) => { e.currentTarget.style.display = "none"; }} />
              <span className="text-sm font-semibold text-slate-700 text-center group-hover:text-[#B8962E] transition-colors">{p.company_name}</span>
            </a>
          ))}
        </div>

        <div className="mt-16 bg-[#0B0F0D] rounded-2xl px-6 py-10 sm:px-12 text-center">
          <h2 className="font-display text-white font-extrabold text-xl sm:text-2xl">Want your company here?</h2>
          <p className="text-gray-400 text-sm mt-2 max-w-lg mx-auto">
            Join our reciprocal Partner Programme — free visibility for your brand plus complimentary Lifetime Partner Access.
          </p>
          <Link to="/become-a-partner" data-testid="partners-become-btn"
            className="inline-block mt-5 bg-gradient-to-r from-amber-500 to-yellow-500 text-slate-950 font-extrabold px-8 py-3.5 rounded-xl hover:brightness-105 active:scale-[0.98] transition-all">
            BECOME A PARTNER
          </Link>
        </div>
      </div>
    </div>
  );
}
